import store from '@/store'
import axios from 'axios'

export default {

  async patchPresentations (presentations) {
    try {
      let result = await axios.patch(store.getters.getOpaApi +'/company/' + store.state.company.Id,
        {presentations: presentations})
      if (!result.data) {
        return {error: true, msg:'error ao salvar apresentações'}
      } else {
        return result.data
      }
    } catch(e) {
      console.log(e)
      return {error: true, msg:'error ao salvar apresentações'}
    }

  }

}